<template>
    <tr v-if='edit'>
        <td>
            &nbsp;
        </td>
        <td>
            <input v-model='value["start_at"]' type='time' class="col-8"> - <input v-model='value["end_at"]' type='time' class="col-8">
        </td>
        <td>
            <select class="form-control" v-model='value["appointment_session_type_id"]'>
                <option :key='id' v-for='(session_type, id) in appointment_session_type' :value='session_type.id'>{{session_type.name}}</option>
            </select>
        </td>
        
        <td><button v-on:click.prevent='$emit("remove")' class="btn btn-round btn-block btn-danger">{{ $t('translations.remove')}}</button></td>
    </tr>
    <tr v-else>
        <td>
            &nbsp;
        </td>
        <td>
            {{value["start_at"]}} - {{value["end_at"]}}
        </td>
        <td>
            {{appointment_session_type.find(obj => {return obj.id == value["appointment_session_type_id"]}).name}}
        </td>
    </tr>
</template>

<script>

export default {
    name: 'appointment-session',
    props: {
        value: {
            
        },
        edit: {
            default: false
        },
        appointment_session_type: {

        }
    },
    
    data() {
        return {
            day: null,
            month: null,
            year: null,
            currentYear: (new Date()).getFullYear(),
            blurTimeout: null,
        };
    },
    computed: {

    },
    watch: {
        appointment_session_type: {
            handler: function() {
                //console.log("HERE");
                //console.log(this.appointment_session_type.find(obj => {return obj.id == this.value["appointment_session_type_id"]}));
                if(!this.appointment_session_type.find(obj => {return obj.id == this.value["appointment_session_type_id"]})) {
                    this.value["appointment_session_type_id"] = "";
                }
            },
            deep: true
        }


    },
    methods: {

    },
};
</script>